import { render, staticRenderFns } from "./CommonlyProtectedAreas.vue?vue&type=template&id=8e7c27d0&"
import script from "./CommonlyProtectedAreas.vue?vue&type=script&lang=js&"
export * from "./CommonlyProtectedAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports